import { Loader2, CircleAlert, Inbox } from "lucide-react";

export const PageTitle = ({ kicker, title, subtitle, children, testId }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4 rise">
    <div>
      {kicker && <p className="font-data text-xs uppercase tracking-[0.2em] text-amber-400">{kicker}</p>}
      <h1 data-testid={testId} className="font-heading text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">{title}</h1>
      {subtitle && <p data-testid={testId ? `${testId}-subtitle` : undefined} className="mt-2 text-base text-muted-foreground md:text-lg">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Loading = ({ label = "Chargement…" }) => (
  <div data-testid="loading" className="flex items-center gap-3 py-16 text-muted-foreground">
    <Loader2 className="h-5 w-5 animate-spin text-amber-400" /> {label}
  </div>
);

export const ErrorBox = ({ message, onRetry }) => (
  <div data-testid="error-box" role="alert" className="flex flex-wrap items-center gap-3 rounded-lg border border-red-500/50 bg-red-950/50 p-4 text-red-100">
    <CircleAlert className="h-5 w-5" /> <span className="flex-1">{message}</span>
    {onRetry && <button data-testid="error-retry" onClick={onRetry} className="rounded-md border border-red-400/60 px-3 py-1.5 text-sm hover:bg-red-900/50">Réessayer</button>}
  </div>
);

export const Empty = ({ children, testId }) => (
  <div data-testid={testId} className="flex items-center gap-3 rounded-lg border border-dashed border-border p-6 text-sm text-muted-foreground">
    <Inbox className="h-5 w-5" /> {children}
  </div>
);

export const FieldError = ({ error, testId }) =>
  error ? (
    <p data-testid={testId} role="alert" className="mt-2 flex items-start gap-1.5 text-sm font-medium text-red-300">
      <CircleAlert className="mt-0.5 h-4 w-4 shrink-0" /> {error}
    </p>
  ) : null;

export const Section = ({ title, icon: Icon, children, testId, field, error, right }) => (
  <section
    data-testid={testId}
    data-field={field}
    className={`rounded-xl border bg-card p-4 sm:p-6 ${error ? "border-red-500/70" : "border-border"}`}
  >
    <div className="mb-4 flex items-center justify-between gap-3">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold uppercase tracking-wide md:text-xl">
        {Icon && <Icon className="h-5 w-5 text-amber-400" />} {title}
      </h2>
      {right}
    </div>
    {children}
  </section>
);

export const InfoItem = ({ label, value, testId, hint }) => (
  <div className="min-w-0">
    <p className="font-data text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <p data-testid={testId} className="mt-1 break-words font-medium">{value}</p>
    {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
  </div>
);
